(function () {
    'use strict';

    angular
        .module('app')
        .controller('download', download);

    download.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'downloadService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService'];

    function download($location, scope, $rootScope, gridDataService, $q, downloadService, $timeout, $mdDialog, records, command, commandService, loginService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'download';



        scope.qualifiedUsersArray = [];

        scope.$on('downloadButtonClicked', function (event, arg) {
            scope.onDownloadButtonClicked(arg.selectionItemList);
        });

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {

            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });

            // Get the selected items.
            var items = [];
//            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
//                item.isSelected = true;
//                items.push(item.selectionItem);
//            });

            // Build the SL with mode and order.
            var selectionItemList = { mode: 0, order: 0, list: items };
        };

        // On click of the Download button.
        scope.onDownloadButtonClicked = function (selectionItemList) {
            // scope
            scope.selectionItemList = selectionItemList;
            scope.showFirstForm = true;
            scope.showCancelButton = true;
            scope.showLoadingPanel = false;


            // dialog config
            scope.heading = loginService.resourceStrings["DOWNLOAD"]; // "Download";
            scope.filesLabel = loginService.resourceStrings["DOWNLOAD_FILESTODOWNLOAD"]; // "Files to Download:";
            scope.labelIncludeChidren = loginService.resourceStrings["DOWNLOAD_INCLUDECHILDREN"]; // "Include Children:";
            scope.labelZipFiles = loginService.resourceStrings["DOWNLOAD_ZIPFILES"]; // "Zip Files:";
            scope.labelZipPassword = loginService.resourceStrings["DOWNLOAD_ZIPPASSWORD"]; // "Zip Password:";
            scope.readyToDownloadLabel = loginService.resourceStrings["DOWNLOAD_READYFORDOWNLOAD"]; // "Your file(s) are ready for download:";
            scope.downloadInstructions = loginService.resourceStrings["DOWNLOAD_INSTRUCTIONS"]; // "The files are ready for download. Click each link below to save or open the file.";
            scope.loadingMessage = loginService.resourceStrings["LOADING_DATA"]; // "Loading...";

            scope.noRecordsFound = loginService.resourceStrings["NO_RECORDS_FOUND"]; // "No records found"
            scope.optionalPassword = loginService.resourceStrings["OPTIONAL_PASSWORD"]; // "(Optional) alpha-numeric password

            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumnsList();
            scope.downloadFiles = [];
            scope.includeChildren = false;
            scope.zipFiles = true;
            scope.zipPassword = "";

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.selectionItemList.list, function (item) {
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename,
                    library: item.detailedInfo.libName,
                });
                index++;
            });

            // Enables.
            scope.selectItem();
            // Do modal.
            $timeout(function () {
                refreshGrid();
                //scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
            scope.showLoadingPanel = false;

        };

        scope.doColumnsList = function () {
            // dialog config columns
            scope.gridOptions.columnDefs[0].name = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            scope.gridOptions.columnDefs[1].name = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
        }

        scope.doColumnsLinks = function () {
            // dialog config columns
            scope.gridOptions.columnDefs[0].name = loginService.resourceStrings["NAME"];
        }

        scope.onDownloadDialogOK = function () {
            // Second form (with download links) clicked will simply close the dialog.
            if (scope.showSecondForm == true &&
                scope.showFirstForm == false) {
                $mdDialog.hide();
            }
            // First click of OK will hide the first form and show second form with download links
            if (scope.showFirstForm == true) {
                // Hide the first form
                scope.showFirstForm = false;
                scope.showLoadingPanel = true;
                scope.showCancelButton = false;
                scope.showSecondForm = true;
                var options = { IncludeChildren: scope.includeChildren, ZipFiles: scope.zipFiles, ZipPassword: scope.zipPassword};

                scope.doColumnsLinks();

                // Execute.
                downloadService.Download(options, scope.selectionItemList).then(function (response) {

                    // Modified so that the items contain a SelectionItem that can be passed to the error dialog.
                    var items = []; // SelectionItems. Only errors in this case.
                    var slx = { mode: 0, order: 0, list: items }; // The base selection list.

                    scope.gridLinks.data = [];
                    var index = 0;

                    // Handle download errors.
                    var atLeastOneError = false;
                    angular.forEach(response.data, function (item) {
                        // Allow this to process more than one error. - if (atLeastOneError == false) {
                            if (item.ReturnErrorCode != 0) {
                                atLeastOneError = true;
                                items.push(item.si); // Add a selection item to the selection list.
                            }
                            else {
                                scope.downloadFiles.push(item);
                                scope.gridLinks.data.push({
                                    index: index,
                                    selectionItem: item,
                                    isSelected: true,
                                    name: item.Filename,
                                    url: item.FileUrl,
                                });
                                index++;
                            }
                    });

                    // Put up the error handler through the command service.
                    scope.showLoadingPanel = false;
                    if (atLeastOneError) {
                        var records = {}; // The call below takes this records object.
                        records.slx = slx; // The main list of errors.
                        commandService.launchErrors(records);
                    }

                    // Populate the grid.
                    $timeout(function () {
                        refreshGrid();
                        //scope.gridApi.selection.selectAllRows();
                        $timeout(function () {
                            refreshGrid();
                        }, 2000);
                    }, 500);
                    scope.showLoadingPanel = false;


                }, function (response) {
                    // Error occurred in download
                    console.log(response);
                    scope.errorMessage = response.data['Message']
                    scope.readyToDownloadLabel = '';
                    scope.downloadInstructions = '';
                    // Done
                    scope.showLoadingPanel = false;
                });
            }
        };

        scope.onDownloadDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.assignDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            //gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            //gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);

            //after the grid has been initialized
            switch (command) {
                case "download":
                    scope.onDownloadButtonClicked(records);
                    break;
            }

        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            enableCellEdit: true,
            enableCellEditOnFocus: true,
            columnDefs: [
                { name: 'Filename', enableCellEdit: true, field: 'name', width: '50%', minWidth: '100' },
                { name: 'Library', enableCellEdit: true, field: 'library', width: '50%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        var linkCellTemplate = '';
        if (bowser.msie || bowser.mobile || bowser.tablet ) {
            linkCellTemplate = '<div><a href="{{grid.appScope.getUrl(grid,row)}}" target="_blank">{{ grid.appScope.getFilename(grid,row) }}</a></div>';
        }
        else {
            linkCellTemplate = '<div><a href="{{grid.appScope.getUrl(grid,row)}}" download>{{ grid.appScope.getFilename(grid,row) }}</a></div>';
        }
        scope.gridLinks = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            enableCellEdit: true,
            enableCellEditOnFocus: true,
                columnDefs: [
                { name: 'Filename', field: 'name', width: '100%', minWidth: '100', cellTemplate: linkCellTemplate }],
        onRegisterApi: onRegisterApi
        }

        // File properties
        scope.getFilename = function (grid, myRow) {
            var item = scope.getItem(grid, myRow);
            if (item != null) return item.name;
            return null;
        }

        // File properties
        scope.getUrl = function (grid, myRow) {
            var item = scope.getItem(grid, myRow);
            if (item != null) return item.url;
            return null;
        }

        scope.getItem = function (grid, myRow) {
            var index = scope.getRowIndex(grid, myRow);
            return scope.gridLinks.data[index];
        }

        scope.getRowIndex = function (grid, myRow) {
            var myRowFound = false;
            var rowIndex = 0;
            grid.renderContainers.body.visibleRowCache.forEach(function (row, index) {
                if (!myRowFound) {
                    if (row === myRow) {
                        myRowFound = true;
                        rowIndex = index;
                    }
                }
            });
            return rowIndex;
        };

        activate();

        function activate() { }
    }
})();
